var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreenGradientCaret4B50Abab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 13,
    viewBox: "0 0 7 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.425 6.5001C6.425 6.7001 6.325 6.9001 6.125 7.0001L1.325 11.8001C1.025 12.1001 0.525 12.1001 0.225 11.8001C-0.075 11.5001 -0.075 11.0001 0.225 10.7001L4.425 6.5001L0.325 2.3001C0.025 2.0001 0.025 1.5001 0.325 1.2001C0.625 0.900098 1.125 0.900098 1.425 1.2001L6.125 6.0001C6.325 6.1001 6.425 6.3001 6.425 6.5001Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.425 6.5001C6.425 6.7001 6.325 6.9001 6.125 7.0001L1.325 11.8001C1.025 12.1001 0.525 12.1001 0.225 11.8001C-0.075 11.5001 -0.075 11.0001 0.225 10.7001L4.425 6.5001L0.325 2.3001C0.025 2.0001 0.025 1.5001 0.325 1.2001C0.625 0.900098 1.125 0.900098 1.425 1.2001L6.125 6.0001C6.325 6.1001 6.425 6.3001 6.425 6.5001Z",
    fill: "url(#paint0_linear_9970_10809)",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.425 6.5001C6.425 6.7001 6.325 6.9001 6.125 7.0001L1.325 11.8001C1.025 12.1001 0.525 12.1001 0.225 11.8001C-0.075 11.5001 -0.075 11.0001 0.225 10.7001L4.425 6.5001L0.325 2.3001C0.025 2.0001 0.025 1.5001 0.325 1.2001C0.625 0.900098 1.125 0.900098 1.425 1.2001L6.125 6.0001C6.325 6.1001 6.425 6.3001 6.425 6.5001Z",
    fill: "url(#paint1_linear_9970_10809)",
    fillOpacity: 0.8
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9970_10809",
    x1: 6.425,
    y1: 12.0251,
    x2: -3.1783,
    y2: 6.44128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9970_10809",
    x1: 0,
    y1: 0.975098,
    x2: 9.51087,
    y2: 6.61253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "rgb(56 120 244 )"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenGradientCaret4B50Abab);
export default __webpack_public_path__ + "static/media/greenGradientCaret.4b50abab.5e44627832dc6cef0cd0cf7946e83e36.svg";
export { ForwardRef as ReactComponent };